<template>
    <form-view class="audio-service-detail-view">
        <template slot="field">
           <veui-field label="应用名称：">
                <veui-span>{{ store.serviceDetail.appName }}</veui-span>
            </veui-field>
            <veui-field label="服务名称：">
                <veui-span>{{ store.serviceDetail.name }}</veui-span>
            </veui-field>
            <veui-field label="语言设置：">
                <veui-span>{{ store.languageMap[lan] }}</veui-span>
            </veui-field>
            <veui-field label="语速设置：">
                <veui-span>{{ speed }}</veui-span>
            </veui-field>
            <veui-field label="语调设置：">
                <veui-span>{{ intonation }}</veui-span>
            </veui-field>
            <veui-field label="音量设置：">
                <veui-span>{{ volume }}</veui-span>
            </veui-field>
            <veui-field label="音色设置：">
                <veui-span>{{ store.timbreMap[timbre] }}</veui-span>
            </veui-field>
            <veui-field label="测试文本："
                tip="输入需要试听播放的内容，最多可输入500个字符">
                <veui-textarea
                    v-model="store.text"/>
            </veui-field>
            <div class="audio-demo">
                <veui-button :disabled="!store.text" @click="store.reuqestDemo()">生成试听音频</veui-button>
                <veui-span class="demo-tip">该文本仅用来测试音频的播放效果，非实际投放要播放的文本内容</veui-span>
                <muse-audio v-if="store.audioDemo" auto-play class="muse-audio-player" :src="store.audioDemo"/>
            </div>
        </template>
        <template slot="operation">
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import DetailModel from './DetailModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Button, Span, Textarea} from 'veui';
import Audio from '@/common/components/media/Audio';
import serviceMixin from '@/common/mixins/service';
import {get} from 'lodash';

export default createView(FormView, DetailModel, {
    name: 'AudioServiceDetailView',
    components: {
        'veui-field': Field,
        'veui-span': Span,
        'veui-button': Button,
        'veui-textarea': Textarea,
        'muse-audio': Audio
    },
    mixins: [serviceMixin],
    computed: {
        lan() {
            return get(this.store.serviceDetail, 'data.lan');
        },
        speed() {
            return get(this.store.serviceDetail, 'data.speed');
        },
        intonation() {
            return get(this.store.serviceDetail, 'data.intonation');
        },
        volume() {
            return get(this.store.serviceDetail, 'data.volume');
        },
        timbre() {
            return get(this.store.serviceDetail, 'data.timbre');
        }
    }
});
</script>

<style lang="less">
.audio-service-detail-view {
    .audio-demo {
        display: block;
        margin-left: 120px
    }
    .demo-tip {
        margin-left: 10px;
    }
}
</style>
